
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import TrapMarkerSpikes from "../../editor/trap-markers/jungle/TrapMarkerSpikes";
import PlatformMarkerFoliage2 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage2";
import SmashableMarkerVine from "../../editor/entity-markers/SmashableMarkerVine";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import RelicMarker from "../../editor/RelicMarker";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkRelic2 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 7246, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -86, 808);
    this.add(trunk_png_2);

    // platformMarkerFoliage_6
    const platformMarkerFoliage_6 = new PlatformMarkerFoliage4(scene, -68, 496);
    this.add(platformMarkerFoliage_6);

    // trunk_png_6
    const trunk_png_6 = new DecorationTrunk(scene, 637, 635);
    this.add(trunk_png_6);

    // platformFoliage_5
    const platformFoliage_5 = new PlatformFoliage2(scene, 641, 328);
    this.add(platformFoliage_5);

    // trunk_png_8
    const trunk_png_8 = new DecorationTrunk(scene, 1126, 491);
    this.add(trunk_png_8);

    // trunk_png_10
    const trunk_png_10 = new DecorationTrunk(scene, 2276, 802);
    this.add(trunk_png_10);

    // platformFoliage_6
    const platformFoliage_6 = new PlatformFoliage1(scene, 1134, 183);
    this.add(platformFoliage_6);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 627, 200);
    this.add(gemMarker_13);

    // trapSpikesMarker
    const trapSpikesMarker = new TrapMarkerSpikes(scene, 2270, 393);
    this.add(trapSpikesMarker);

    // platformMarkerFoliage_12
    const platformMarkerFoliage_12 = new PlatformMarkerFoliage4(scene, 2285, 478);
    this.add(platformMarkerFoliage_12);

    // platformMarkerFoliage_14
    const platformMarkerFoliage_14 = new PlatformMarkerFoliage2(scene, 2117, -115);
    this.add(platformMarkerFoliage_14);

    // platformFoliage_8
    const platformFoliage_8 = new PlatformFoliage1(scene, 1658, 20);
    this.add(platformFoliage_8);

    // trunk_png_12
    const trunk_png_12 = new DecorationTrunk(scene, 1694, 869);
    this.add(trunk_png_12);

    // gemMarker_17
    const gemMarker_17 = new SmallGemMarker(scene, 1683, -63);
    this.add(gemMarker_17);

    // platformMarkerFoliage_17
    const platformMarkerFoliage_17 = new PlatformMarkerFoliage4(scene, 3764, -377);
    this.add(platformMarkerFoliage_17);

    // trapSpikesMarker_3
    const trapSpikesMarker_3 = new TrapMarkerSpikes(scene, 3846, -450);
    this.add(trapSpikesMarker_3);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 4204, -419);
    this.add(gemMarker_15);

    // smashableMarkerVine_4
    const smashableMarkerVine_4 = new SmashableMarkerVine(scene, 4397, -485);
    this.add(smashableMarkerVine_4);

    // platformMarkerFoliage_18
    const platformMarkerFoliage_18 = new PlatformMarkerFoliage4(scene, 4312, -279);
    this.add(platformMarkerFoliage_18);

    // platformFoliage_9
    const platformFoliage_9 = new PlatformFoliage1(scene, 4413, -633);
    this.add(platformFoliage_9);

    // trunk_png_11
    const trunk_png_11 = new DecorationTrunk(scene, 2911, 880);
    this.add(trunk_png_11);

    // platformMarkerFoliage_19
    const platformMarkerFoliage_19 = new PlatformMarkerFoliage2(scene, 5237, -396);
    this.add(platformMarkerFoliage_19);

    // platformMarkerFoliage_20
    const platformMarkerFoliage_20 = new PlatformMarkerFoliage2(scene, 5521, -319);
    this.add(platformMarkerFoliage_20);

    // platformMarkerFoliage_21
    const platformMarkerFoliage_21 = new PlatformMarkerFoliage4(scene, 4976, -264);
    this.add(platformMarkerFoliage_21);

    // platformMarkerFoliage_22
    const platformMarkerFoliage_22 = new PlatformMarkerFoliage2(scene, 2911, 569);
    this.add(platformMarkerFoliage_22);

    // platformMarkerFoliage_23
    const platformMarkerFoliage_23 = new PlatformMarkerFoliage2(scene, 3783, 490);
    this.add(platformMarkerFoliage_23);

    // trunk_png_13
    const trunk_png_13 = new DecorationTrunk(scene, 3782, 788);
    this.add(trunk_png_13);

    // relicMarker_1
    const relicMarker_1 = new RelicMarker(scene, 5529, -395);
    this.add(relicMarker_1);

    // platformMarkerFoliage_25
    const platformMarkerFoliage_25 = new PlatformMarkerFoliage3(scene, 4360, 602);
    this.add(platformMarkerFoliage_25);

    // smashableMarkerVine_6
    const smashableMarkerVine_6 = new SmashableMarkerVine(scene, 4372, 406);
    this.add(smashableMarkerVine_6);

    // platformMarkerFoliage_24
    const platformMarkerFoliage_24 = new PlatformMarkerFoliage3(scene, 5925, 312);
    this.add(platformMarkerFoliage_24);

    // trunk_png_14
    const trunk_png_14 = new DecorationTrunk(scene, 5913, 609);
    this.add(trunk_png_14);

    // trunk_png_15
    const trunk_png_15 = new DecorationTrunk(scene, 5414, 726);
    this.add(trunk_png_15);

    // platformMarkerFoliage_28
    const platformMarkerFoliage_28 = new PlatformMarkerFoliage4(scene, 6143, -97);
    this.add(platformMarkerFoliage_28);

    // platformMarkerFoliage_29
    const platformMarkerFoliage_29 = new PlatformMarkerFoliage4(scene, 6671, 266);
    this.add(platformMarkerFoliage_29);

    // trunk_png_16
    const trunk_png_16 = new DecorationTrunk(scene, 3323, 799);
    this.add(trunk_png_16);

    // platformMarkerFoliage_30
    const platformMarkerFoliage_30 = new PlatformMarkerFoliage2(scene, 3323, 498);
    this.add(platformMarkerFoliage_30);

    // platformMarkerFoliage_31
    const platformMarkerFoliage_31 = new PlatformMarkerFoliage2(scene, 2451, -198);
    this.add(platformMarkerFoliage_31);

    // trapSpikesMarker_5
    const trapSpikesMarker_5 = new TrapMarkerSpikes(scene, 2458, -250);
    this.add(trapSpikesMarker_5);

    // platformMarkerFoliage_32
    const platformMarkerFoliage_32 = new PlatformMarkerFoliage2(scene, 2711, -144);
    this.add(platformMarkerFoliage_32);

    // platformFoliage_10
    const platformFoliage_10 = new PlatformFoliage1(scene, 3089, -259);
    this.add(platformFoliage_10);

    // platformMarkerFoliage_15
    const platformMarkerFoliage_15 = new PlatformMarkerFoliage3(scene, 4882, 463);
    this.add(platformMarkerFoliage_15);

    // trunk_png_17
    const trunk_png_17 = new DecorationTrunk(scene, 4870, 762);
    this.add(trunk_png_17);

    // platformMarkerFoliage_33
    const platformMarkerFoliage_33 = new PlatformMarkerFoliage2(scene, 5380, 427);
    this.add(platformMarkerFoliage_33);

    // gemMarker_26
    const gemMarker_26 = new SmallGemMarker(scene, 6547, 109);
    this.add(gemMarker_26);

    // gemMarker_27
    const gemMarker_27 = new SmallGemMarker(scene, 6767, 111);
    this.add(gemMarker_27);

    // trapSpikesMarker_1
    const trapSpikesMarker_1 = new TrapMarkerSpikes(scene, 4408, -685);
    this.add(trapSpikesMarker_1);

    // platformMarkerFoliage_27
    const platformMarkerFoliage_27 = new PlatformMarkerFoliage2(scene, 4394, 254);
    this.add(platformMarkerFoliage_27);

    // trapSpikesMarker_6
    const trapSpikesMarker_6 = new TrapMarkerSpikes(scene, 5131, -329);
    this.add(trapSpikesMarker_6);

    // trapSpikesMarker_7
    const trapSpikesMarker_7 = new TrapMarkerSpikes(scene, 5219, -445);
    this.add(trapSpikesMarker_7);

    // decorationTrunk
    const decorationTrunk = new DecorationTrunk(scene, 6715, 576);
    this.add(decorationTrunk);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 4361, 897);
    this.add(trunk_png);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 3098, -410);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2710, -287);
    this.add(gemMarker_3);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -229, 426);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 5954, -172);
    this.add(checkpointMarker_1);

    // trapSpikesMarker_2
    const trapSpikesMarker_2 = new TrapMarkerSpikes(scene, 4390, 208);
    this.add(trapSpikesMarker_2);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 4479, -379);
    this.add(gemMarker_1);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 4532, -421);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 4477, -455);
    this.add(gemMarker_6);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 2092, -206);
    this.add(gemMarker_4);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 2145, -248);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 2090, -282);
    this.add(gemMarker_8);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 3547, -493);
    this.add(gemMarker);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 3600, -535);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 3545, -569);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 1127, 89);
    this.add(gemMarker_11);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 1180, 47);
    this.add(gemMarker_12);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 1125, 13);
    this.add(gemMarker_14);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage3(scene, 1708, 562);
    this.add(platformMarkerFoliage);

    // this (components)
    new ChunkBoundaries(this);

    // smashableMarkerVine_4 (components)
    const smashableMarkerVine_4SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine_4);
    smashableMarkerVine_4SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerVine_6 (components)
    const smashableMarkerVine_6SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine_6);
    smashableMarkerVine_6SimpleBreakableBlocker.allowedCharacter = "panda";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
